import { combineReducers } from 'redux';

import companyForm from './companyForm';

const leadgen = combineReducers({
  companyForm,
});

export default leadgen;
